<template>
  <div class="party-company">
    <div class="banner" @click="unionIntroduce"><img src="@/assets/twoStar/dpCommerceItem/unionIntroduceBanner.jpg" alt=""></div>
    <div class="company-box">
      <div class="company-template" v-for="company in companys" :key="company.id" @click="goDetail(company.id)">
        <img :src="company.photo | img" alt />
        <p v-text="company.headline"></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      companys: []
    };
  },
  created: function() {
    this.axios({
      url:'/api/Main/Member',
      params:{
        name:'东坡水街商圈综合党委'
      }
    }).then(e => {
        switch (e.data.code) {
          case 0:
            this.companys = e.data.msg;
            break;
          case 1:
            this.$message.warning(e.data.msg)
            break;
          case 3:
            this.$router.push("login");
            break;
          default:
            alert("服务器错误,请稍后重试");
            break;
        }
      })
      .catch(err => {
        console.log(err);
      });
  },
  methods:{
    goDetail(companyId){
      this.$router.push({path:'/pubLicDetail',query:{title:'水街联盟',id:companyId,dbnum:1}})
    },
    unionIntroduce() {
      this.$router.push({ path: '/unionIntroduce', query: { title: '联盟简介' } })
    }
  },
};
</script>

<style lang="scss" scoped>
.party-company {
  .banner {
    width: 100%;
    display: grid;
    place-items: center;
    margin-top: 0.1rem;
    img {
      width: 95%;
    }
  }
  .company-box {
    .company-template {
      &:nth-child(odd){
          margin-right: 4%;
      }
      p{
          line-height: 2;
          padding-left: .2rem;
      }
      img {
        width: 100%;
        height: 2rem;
      }
      box-shadow: 0px 0px .1rem 0px rgba(0, 0, 0, 0.1);
      border-radius: .04rem;
      width: 48%;
      margin-top: .3rem;
    }
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 94%;
    margin: 0 auto;
    align-items: center;
  }
  padding-top: 1rem;
  font-size: 0.3rem;
  background: #fff;
  min-height: 100vh;
}
</style>